jQuery(document).ready(function(){
  function initSlick() {
    if ($(window).width() < 768) {
      if (!$('.tab-sliders').hasClass('slick-initialized')) {
        $('.tab-sliders').slick({
          dots: false,
          infinite: false,
          arrows: true,
          speed: 300,
          slidesToShow: 2.5,
          slidesToScroll: 1,
        });
      }
    } else {
      if ($('.tab-sliders').hasClass('slick-initialized')) {
        $('.tab-sliders').slick('unslick'); // disable on desktop
      }
    }
  }

  // Run on load
  initSlick();

  // Run on resize
  $(window).on('resize', function(){
    initSlick();
  });
});
